//node modules
import {Col, Navbar, Row} from "reactstrap";
import {NavLink} from "react-router-dom";


//icons
import UserControls from "./components/UserControls";
import SideMenu from "./components/MenuButton";

//media
//validators
import {useSettingStore} from "../../../context/settings";
import shallow from "zustand/shallow";

type props = {
  className: string,
}

export default function TopNav({className}: props) {
  const {navbarExtended} = useSettingStore((state) => ({navbarExtended: state.navbarExtended}), shallow);

  return (
    <>
      <Navbar className={className + " row nowrap"} container={false}>
        <Col md="auto" className={"topNav_side"}>
          <NavLink
            className={"topNav_logo"}
            to={"/"}>
            <img className={navbarExtended ? "hidden" : ""} src={"/media/icon.svg"}
                 alt="innsamling small logo"/>
            <img className={!navbarExtended ? "hidden" : ""} src={"/media/logo.png"} alt="innsamling logo"/>
          </NavLink>
        </Col>
        <Row className={"topNav_main nowrap"} sm={"fill"}>
          <Col className={"topNavMain_left"} xs={"auto"}>
            <SideMenu/>
          </Col>
          <Col className={"topNavMain_right"} xs={"fill"}>
            <UserControls/>
          </Col>
        </Row>
      </Navbar>
    </>
  )
}
